module.exports = __webpack_public_path__ + "img/7.81dff50b.png";